import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';
import querystring from 'query-string';
import invariant from 'invariant';

const getContentByComponent = (params) => {
    const { baseUrl, brandId, country, language, componentKey, options, clientId, coreMediaLocale } = params;
    invariant(baseUrl, 'baseUrl is a required param of getContentByComponent()');
    invariant(brandId, 'brandId is a required param of getContentByComponent()');
    invariant(country, 'country is a required param of getContentByComponent()');
    invariant(language, 'language is a required param of getContentByComponent()');
    invariant(componentKey, 'componentKey is a required param of getContentByComponent()');
    invariant(clientId, 'clientId is a required param of getContentByComponent()');

    const headers = new Headers({ 'Content-Type': 'application/json' });
    const localisedBrand = `${brandId}_${country.toLowerCase()}`;
    const langId = coreMediaLocale ? coreMediaLocale : `${language}_${country.toUpperCase()}`;
    const optionalQuery = options ? `&${querystring.stringify(options)}` : '';
    const url = `${baseUrl}blueprint/servlet/component/v2/store/${localisedBrand}/key/${componentKey}?langId=${langId}${optionalQuery}`;

    return labelRequest(authenticatedRequest(new Request(url, { headers }), undefined, clientId), 'getContentByComponent');
};

export default getContentByComponent;
